'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _urls = require('../../../utils/urls');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _caterwaulComponents = require('@liveauctioneers/caterwaul-components');

var _components = require('../../../components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Support = require('./Support.scss');

var _Support2 = _interopRequireDefault(_Support);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var auctionCalendarParams = encodeURIComponent((0, _stringify2.default)({
    catalog_status: 'live,online',
    page: 1,
    pageSize: 120
}));

var Support = function (_Component) {
    (0, _inherits3.default)(Support, _Component);

    function Support() {
        (0, _classCallCheck3.default)(this, Support);
        return (0, _possibleConstructorReturn3.default)(this, (Support.__proto__ || (0, _getPrototypeOf2.default)(Support)).apply(this, arguments));
    }

    (0, _createClass3.default)(Support, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                classicBaseUrl = _props.classicBaseUrl,
                openHealthcheckModal = _props.openHealthcheckModal;


            return (0, _jsx3.default)('div', {
                className: _Support2.default.support
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.container
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'company'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/about'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'about'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: 'https://careers.jobscore.com/careers/liveauctioneers',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'careers'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: baseUrl + '/pages/press'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'press'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: baseUrl + '/news/'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_central_news'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: 'http://liveauctioneers.desk.com/',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'support_center'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: 'http://liveauctioneers.desk.com/customer/portal/emails/new',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'contact_us'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'winning'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/how-it-works'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'how_auctions_work'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                href: baseUrl + '/catalog/search?parameters=' + auctionCalendarParams
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_calendar'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctioneerDirectoryUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_house_directory'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/find-auctions-near-me'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctions_near_you'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getAuctionResultsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auction_result_search'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/mobile'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'mobile'
            })))))), (0, _jsx3.default)('div', {
                className: _Support2.default.column
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.wrapper
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default['column-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'selling'
            })), (0, _jsx3.default)('ul', {}, void 0, (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/features'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'why_sell'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/seller-testimonials'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'seller_testimonials'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: baseUrl + '/pages/sell/'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'become_a_seller'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)(_components.Link, {
                route: true,
                to: '/consignments'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'consign_an_item'
            }))), (0, _jsx3.default)('li', {}, void 0, (0, _jsx3.default)('a', {
                target: '_blank',
                href: classicBaseUrl + '/user/login.html?url=/auctioneers/',
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctioneer_sign_in'
            }))))))), (0, _jsx3.default)('div', {
                className: _Support2.default['container-using']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'using'
            }), ': \xA0', (0, _jsx3.default)('span', {
                className: _Support2.default['new-site']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'the_new_liveauctioneers_site'
            })), ' ', '\xA0', (0, _jsx3.default)('a', {
                href: classicBaseUrl,
                className: _Support2.default['classic-link'],
                rel: 'nofollow'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'classic_site'
            }))), (0, _jsx3.default)('div', {
                className: _Support2.default['social-icons']
            }, void 0, (0, _jsx3.default)('a', {
                className: _Support2.default.email,
                alt: 'Email',
                href: 'http://liveauctioneers.desk.com/customer/portal/emails/new',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.twitter,
                alt: 'Twitter',
                href: 'https://twitter.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.facebook,
                alt: 'Facebook',
                href: 'https://www.facebook.com/LiveAuctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0'), (0, _jsx3.default)('a', {
                className: _Support2.default.pinterest,
                alt: 'Pinterest',
                href: 'https://www.pinterest.com/liveauctioneers/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, '\xA0')), (0, _jsx3.default)('div', {
                className: _Support2.default['container-copyright']
            }, void 0, (0, _jsx3.default)('div', {
                className: _Support2.default.copyright
            }, void 0, (0, _jsx3.default)('span', {}, void 0, '\xA9'), ' ', (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'copyright'
            }), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getTermsAndConditionsUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'terms_and_conditions'
            })), (0, _jsx3.default)(_components.Link, {
                route: true,
                to: (0, _urls.getPrivacyUrl)()
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'privacy_policy'
            })), (0, _jsx3.default)(_caterwaulComponents.Icon, {
                name: 'dashboard',
                onClick: openHealthcheckModal,
                className: _Support2.default.health
            })), (0, _jsx3.default)('div', {
                className: _Support2.default.sitemap
            }, void 0, (0, _jsx3.default)('span', {
                className: _Support2.default['bold-title']
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'sitemap'
            }), ':'), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/browse/archive/page1',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'past_auctions'
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/browse/',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'upcoming_auctions'
            })), (0, _jsx3.default)(_components.Link, {
                to: 'https://www.liveauctioneers.com/search_auctioneers.html',
                target: '_blank',
                rel: 'noopener'
            }, void 0, (0, _jsx3.default)(_reactIntl.FormattedMessage, {
                id: 'auctioneer_directory'
            })))));
        }
    }]);
    return Support;
}(_react.Component);

exports.default = Support;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Support/Support.js
// module id = K8/L
// module chunks = 46